import * as PIXI from "pixi.js";
import { screenHeight, screenWidth } from "../constants";
import { MonologueManager } from "../managers/monologueManager";

type SetupMonologue = Readonly<{
  parent: PIXI.Container;
  ticker: PIXI.Ticker;
  monologueManager: MonologueManager;
}>;
export function setupMonologue({
  parent,
  ticker,
  monologueManager,
}: SetupMonologue) {
  const monologue = new PIXI.Container();

  const bg = new PIXI.Graphics();
  bg.beginFill(0x222222, 0.85).drawRect(0, 0, screenWidth, screenHeight);

  const text = new PIXI.Text(
    monologueManager.text,
    new PIXI.TextStyle({
      align: "center",
      fontSize: 20,
      fill: 0xfefefe,
    }),
  );
  text.anchor.set(0.5, 0.5);
  text.position.set(screenWidth / 2, screenHeight / 2);

  monologue.addChild(bg);
  monologue.addChild(text);
  monologue.position.set(0, 0);
  monologue.zIndex = 1;

  const onTick = () => {
    text.text = monologueManager.text;
  };

  parent.addChild(monologue);
  ticker.add(onTick);
  const dispose = () => {
    parent.removeChild(monologue);
    ticker.remove(onTick);
  };

  return dispose;
}
